import './check.css';
export default {
  "check": "pf-v5-c-check",
  "checkBody": "pf-v5-c-check__body",
  "checkDescription": "pf-v5-c-check__description",
  "checkInput": "pf-v5-c-check__input",
  "checkLabel": "pf-v5-c-check__label",
  "checkLabelRequired": "pf-v5-c-check__label-required",
  "modifiers": {
    "standalone": "pf-m-standalone",
    "disabled": "pf-m-disabled"
  }
};